/*
 * @Author: 孙福聪
 * @Date: 2019-01-16 16:03:08
 * @Last Modified by: 孙福聪
 * @Last Modified time: 2019-03-22 15:29:27
 */
/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import login from "./views/login.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "login",
      component: login,
    },
    {
      path: "/login_middle",
      name: "loginmiddle",
      component() {
        console.log("login_middle");
        return import(/* webpackChunkName: "forgetpassword" */ "./views/loginmiddle.vue");
      },
    },
    {
      path: "/forgetpassword",
      name: "forgetpassword",
      component() {
        return import(/* webpackChunkName: "forgetpassword" */ "./views/forgetpassword.vue");
      },
    },
    {
      path: "/stureport",
      name: "stureport",
      component() {
        return import(/* webpackChunkName: "stureport" */ "./views/Public/stuReport/index.vue");
      },
    },
    {
      // 预览案例页面
      path: "/preview",
      name: "preview",
      component() {
        return import(/* webpackChunkName: "preview" */ "./views/preview/home.vue");
      },
    },
    {
      path: "/Teacher",
      name: "Teacher",
      component() {
        return import(/* webpackChunkName: "Teacher" */ "./views/Teacher/index.vue");
      },
      children: [
        // 这里写教师端的子页面
        {
          // 通知頁面
          path: "/Teacher/notice",
          name: "notice",
          component() {
            return import(/* webpackChunkName: "notice" */ "./views/Teacher/notice.vue");
          },
        },
        {
          // 用户管理
          path: "/Teacher/userlist",
          name: "userList",
          component() {
            return import(
              /* webpackChunkName: "userList" */
              "./views/Teacher/user_manage/index.vue"
            );
          },
        },
        {
          // 个人中心
          path: "/Teacher/personalCenter",
          name: "personalCenter",
          component() {
            return import(
              /* webpackChunkName: "personalCenter" */
              "./views/Public/personalCenter/index.vue"
            );
          },
        },
        {
          // 班级管理
          path: "/Teacher/classlist",
          name: "classList",
          component() {
            return import(
              /* webpackChunkName: "classList" */
              "./views/Teacher/class_manage/index.vue"
            );
          },
        },
        {
          // 实验管理
          path: "/Teacher/experimentManage",
          name: "experimentManage",
          component() {
            return import(
              /* webpackChunkName: "experimentManage" */
              "./views/Teacher/case_manage/index.vue"
            );
          },
        },
        {
          // 报告管理
          path: "/Teacher/reportManage",
          name: "reportManage",
          component() {
            return import(
              /* webpackChunkName: "reportManage" */
              "./views/Teacher/report_manage/index.vue"
            );
          },
        },
        {
          // 报告管理二级页面
          path: "/Teacher/reportManage2",
          name: "reportManage2",
          component() {
            return import(
              /* webpackChunkName: "reportManage2" */
              "./views/Teacher/report_manage/second.vue"
            );
          },
        },
        {
          // 资料中心
          path: "/Teacher/datacenter",
          name: "datacenter",
          component() {
            return import(
              /* webpackChunkName: "datacenter" */
              "./views/Teacher/data_center/index.vue"
            );
          },
        },
        {
          // 自定义案例
          path: "/Teacher/case",
          name: "case",
          component() {
            return import(/* webpackChunkName: "case" */ "./views/Public/case/caseIndex.vue");
          },
        },
        {
          // 审核
          path: "/Teacher/To_examine",
          name: "To_examine",
          component() {
            return import(
              /* webpackChunkName: "To_examine" */
              "./views/Teacher/To_examine/index.vue"
            );
          },
        },
      ],
    },
    {
      // doCase
      path: "/",
      name: "daCase",
      component() {
        return import(/* webpackChunkName: "daCase" */ "./views/Public/stuCase/home.vue");
      },
      children: [
        {
          // 做案例首页
          path: "/doCase",
          name: "doCaseHome",
          component() {
            return import(/* webpackChunkName: "doCaseHome" */ "./views/Public/stuCase/index.vue");
          },
        },
      ],
    },
    {
      // 自定义案例父路由
      path: "/",
      name: "caseIndex",
      component() {
        return import(/* webpackChunkName: "caseIndex" */ "./views/Public/case/index.vue");
      },
      children: [
        {
          // 自定义案例首页
          path: "/case",
          name: "caseBasicInformation",
          component() {
            return import(
              /* webpackChunkName: "caseBasicInformation" */
              "./views/Public/case/basicInformation.vue"
            );
          },
        },
        {
          // 自定义案例政策制定页面
          path: "/case/policy",
          name: "casePolicy",
          component() {
            return import(
              /* webpackChunkName: "casePolicy" */
              "./views/Public/case/policyStage.vue"
            );
          },
        },
      ],
    },
    {
      // 学生端父路由
      path: "/",
      name: "Student",
      component() {
        return import(/* webpackChunkName: "Student" */ "./views/Student/index.vue");
      },
      children: [
        {
          // 学生端首页
          path: "/Student/home",
          name: "studentHome",
          component() {
            return import(/* webpackChunkName: "studentHome" */ "./views/Student/home.vue");
          },
        },
        {
          // 查看详情
          path: "/Student/see_ranking",
          name: "see_ranking",
          component() {
            return import(
              /* webpackChunkName: "see_ranking" */
              "./views/Student/see_ranking/index.vue"
            );
          },
        },
        {
          // 流程演练
          path: "/Student/process_drill",
          name: "process_drill",
          component() {
            return import(
              /* webpackChunkName: "process_drill" */
              "./views/Student/process_drill/index.vue"
            );
          },
        },
        {
          // 通知
          path: "/Student/notice_news",
          name: "notice_news",
          component() {
            return import(
              /* webpackChunkName: "notice_news" */
              "./views/Student/notice_news/index.vue"
            );
          },
        },
        {
          // 案例列表
          path: "/Student/case_list",
          name: "case_list",
          component() {
            return import(
              /* webpackChunkName: "case_list" */
              "./views/Student/case_list/index.vue"
            );
          },
        },
        {
          // 自定义案例
          path: "/Student/custom-case",
          name: "custom-case",
          component() {
            return import(
              /* webpackChunkName: "custom-case" */
              "./views/Student/custom-case/index.vue"
            );
          },
        },
        {
          // 资料中心
          path: "/Student/datacenter",
          name: "stu-datacenter",
          component() {
            return import(
              /* webpackChunkName: "stu-datacenter" */
              "./views/Student/data_center/index.vue"
            );
          },
        },
        ,
        {
          // 资料中心
          path: "/Student/datacenter_t",
          name: "stu-datacenter",
          component() {
            return import(
              /* webpackChunkName: "stu-datacenter-t" */
              "./views/Student/data_center_t/index.vue"
            );
          },
        },
        {
          // 个人中心
          path: "/Student/personal_center",
          name: "personal_center",
          component() {
            return import(
              /* webpackChunkName: "personal_center" */
              "./views/Student/personal_center/index.vue"
            );
          },
        },
      ],
    },
    {
      // 新手引导
      path: "/Novice_guide",
      name: "Novice_guide",
      component() {
        return import(/* webpackChunkName: "Novice_guide" */ "./components/Novice_guide/index.vue");
      },
    },
  ],
});
